export const FEATURES_LIST = [{
  title: '海量金融数据',
  desc: '同花顺金融数据库集成了金融市场主要品种的全部基本信息、财务数据和交易数据，并对集成的数据进行结构化、标准化处理，使得数据更容易理解和阅读',
  img: require('@/assets/images/persoanl/feature_01.png')
}, {
  title: '人工智能赋能',
  desc: '依托海量用户数据多次对算法模型进行机器训练和优化，沉淀出成熟的人工智能技术，将其对广大合作伙伴进行开放',
  img: require('@/assets/images/persoanl/feature_02.png')
}, {
  title: '高灵活度的接入方案',
  desc: '支持包括数据接口、云端组件、定制化开发及本地部署在内的多套接入方案，客户可在接入速度与个性化程度间灵活权衡',
  img: require('@/assets/images/persoanl/feature_03.png')
}, {
  title: '丰富的产品体系',
  desc: '依托同花顺巨大的C端用户体量，为B端提供基于百万量级的用户行为分析诞生的产品，具有高可用性',
  img: require('@/assets/images/persoanl/feature_04.png')
}];